import { TRANSACTION_HISTORY } from "api/ApiPath";
import { BaseApiResponseModel } from "api/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "api/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { isEmpty } from "lodash";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { TravelSimRegistrationRequestModel } from "./model/TravelSimRegistrationRequestModel";
import { TravelSimRegistrationResponseModel } from "./model/TravelSimRegistrationResponseModel";

export interface ITravelSimRegistrationRepository {
  getOutboundList(
    params: TravelSimRegistrationRequestModel
  ): Promise<ListBaseApiResponseModel<TravelSimRegistrationResponseModel>>;
  getInboundList(
    params: TravelSimRegistrationRequestModel
  ): Promise<ListBaseApiResponseModel<TravelSimRegistrationResponseModel>>;
  getDetail(
    params: TravelSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<TravelSimRegistrationResponseModel>>;
  inboundExportReport(
    params: TravelSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<Blob>>;
  outboundExportReport(
    params: TravelSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<Blob>>;
}

@injectable()
export class TravelSimRegistrationImpl
  implements ITravelSimRegistrationRepository
{
  async getOutboundList(
    params: TravelSimRegistrationRequestModel
  ): Promise<ListBaseApiResponseModel<TravelSimRegistrationResponseModel>> {
    let queryString = Object?.entries(params)
      ?.filter(
        ([_, vals]) =>
          Array.isArray(vals) && !isEmpty(vals) && !vals?.includes("")
      )
      ?.map(([keys, vals]) => DataFormat.getQueryString(vals, keys))
      ?.join("&");
    DataFormat.removeArrayTypeValue(params);
    return await client?.get(
      `${TRANSACTION_HISTORY.OUTBOUNDLIST}${
        !isEmpty(queryString) ? `?${queryString}` : ""
      }`,
      params
    );
  }

  async getInboundList(
    params: TravelSimRegistrationRequestModel
  ): Promise<ListBaseApiResponseModel<TravelSimRegistrationResponseModel>> {
    let queryString = Object?.entries(params)
      ?.filter(
        ([_, vals]) =>
          Array.isArray(vals) && !isEmpty(vals) && !vals?.includes("")
      )
      ?.map(([keys, vals]) => DataFormat.getQueryString(vals, keys))
      ?.join("&");
    DataFormat.removeArrayTypeValue(params);
    return await client?.get(
      `${TRANSACTION_HISTORY.INBOUNDLIST}${
        !isEmpty(queryString) ? `?${queryString}` : ""
      }`,
      params
    );
  }

  async getDetail(
    params: TravelSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<TravelSimRegistrationResponseModel>> {
    return;
  }

  async inboundExportReport(
    params: TravelSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<Blob>> {
    delete params?.typeofSim;
    let queryString = Object?.entries(params)
      ?.filter(
        ([_, vals]) =>
          Array.isArray(vals) && !isEmpty(vals) && !vals?.includes("")
      )
      ?.map(([keys, vals]) => DataFormat.getQueryString(vals, keys))
      ?.join("&");
    DataFormat.removeArrayTypeValue(params);
    const queryParams = new URLSearchParams(
      params as unknown as URLSearchParams
    )?.toString();
    const url = `${TRANSACTION_HISTORY.INBOUNDLIST}${
      !isEmpty(queryString) ? `?${queryString}` : ""
    }${isEmpty(queryString) ? `?${queryParams}` : `&${queryParams}`}`;
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to export report: ${response.statusText}`);
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }

  async outboundExportReport(
    params: TravelSimRegistrationRequestModel
  ): Promise<BaseApiResponseModel<Blob>> {
    delete params?.typeofSim;
    let queryString = Object?.entries(params)
      ?.filter(
        ([_, vals]) =>
          Array.isArray(vals) && !isEmpty(vals) && !vals?.includes("")
      )
      ?.map(([keys, vals]) => DataFormat.getQueryString(vals, keys))
      ?.join("&");
    DataFormat.removeArrayTypeValue(params);
    const queryParams = new URLSearchParams(
      params as unknown as URLSearchParams
    )?.toString();
    const url = `${TRANSACTION_HISTORY.OUTBOUNDLIST}${
      !isEmpty(queryString) ? `?${queryString}` : ""
    }${isEmpty(queryString) ? `?${queryParams}` : `&${queryParams}`}`;
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to export report: ${response.statusText}`);
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }
}
